import {atom} from 'recoil';

import {IContract} from '../../shared/types/contract.types';
import {IDocument} from '../../shared/types/document.types';
import {IPageableDto, IPageableTable} from '../../shared/types/pageable.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export const contractsQueryTrigger = atom<number>({
  key: 'contractsQueryTrigger',
  default: 0,
});

export const documentsOfContractQueryTrigger = atom<number>({
  key: 'documentsOfContractQueryTrigger',
  default: 0,
});

export const currentContractIdState = atom<number | null>({
  key: 'currentContractIdState',
  default: null,
});

export const contractsState = atom<IPageableDto<IContract>>({
  key: 'contractsState',
  default: getEmptyPage<IContract>(),
});

export const currentContractState = atom<IContract | null>({
  key: 'currentContractState',
  default: null,
});

export const documentsOfCurrentContractState = atom<IDocument[]>({
  key: 'documentsOfCurrentContractState',
  default: [],
});

export const contractPageable = atom<IPageableTable>({
  key: 'contractPageable',
  default: {
    page: 0,
    size: localStorage.getItem('contractsPerPage')
      ? parseInt(localStorage.getItem('contractsPerPage') as string, 10)
      : 5,
  },
});

export const contractsSortQueryTrigger = atom<{field: string; sort: 'asc' | 'desc' | null | undefined}[]>({
  key: 'contractsSortQueryTrigger',
  default: [],
});
